function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPaperPlaneThin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M511.6 36.9c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256C5.5 266.3-.7 277.8.1 290s8.4 22.9 19.6 27.6L160 376v93c0 23.8 19.3 43 43 43s25.4-5.9 33.6-16.1l52.8-66h.1l114.2 47.6c9.1 3.8 19.4 3.2 28-1.6s14.5-13.3 16-23l64-416zm-253 380.2-47 58.8c-2.1 2.6-5.3 4.1-8.6 4.1-6.1 0-11-4.9-11-11v-79.7zm43.1-16.7-96.6-40.3 269-289.6L416 448l-114.2-47.6ZM450.5 48.8 173.6 347 32 288z",
  style: {
    fill: "#df0000"
  }
}));
export default SvgPaperPlaneThin;